import { render, staticRenderFns } from "./RoomOfferFees.vue?vue&type=template&id=32196247&"
import script from "./RoomOfferFees.vue?vue&type=script&lang=js&"
export * from "./RoomOfferFees.vue?vue&type=script&lang=js&"
import style0 from "./RoomOfferFees.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports